/*>
* @license
* Copyright (c) 2014-2022 ABILITY Network, Inc., an INOVALON, Inc. company. All Rights Reserved.
* 
* This computer program is CONFIDENTIAL and a TRADE SECRET of ABILITY Network, Inc.
* The receipt or possession of this program does not convey any rights to use,
* reproduce or disclose its contents in whole or in part, without the specific
* written consent of ABILITY Network, Inc. Any use, reproduction or disclosure of
* this program without the express written consent of ABILITY Network, Inc. is a
* violation of the copyright laws and may subject you to criminal prosecution.
<*/
import { injectable } from 'inversify'
import { injectProperty } from '../../../configuration/ServiceLocator'
import { IJwtStorage } from '../../JwtStorage/contracts'
import { IUserSessionApiClient } from '../../UserSessionApiClient/contracts'
import { UserSession } from '../../UserSessionStateManager/UserSession'
import { IUserSessionMiddleware } from './contracts'
import { SettingsManager } from '../../../configuration/SettingsManager'

@injectable()
export class UserSessionMiddleware implements IUserSessionMiddleware {
	@injectProperty('IJwtStorage')
	jwtStorage!: IJwtStorage

	@injectProperty('IUserSessionApiClient')
	userSessionApiClient!: IUserSessionApiClient

	loadSessionJwt(isTimeoutPopup: boolean): Promise<string> {
		let isSessionExpired = false
		const ssoToken = localStorage.getItem(SettingsManager.REACT_APP_SSO_TOKEN_NAME)

		if (ssoToken !== null) {
			isSessionExpired = UserSession.getUserSessionFromJwt(ssoToken).isExpBeforeNow()
			if (isSessionExpired) {
				console.info('No session active session token found. Attempting to load SSO token to exchange for new session.')
			}
		} else {
			console.info('No session active session token found. Attempting to load SSO token to exchange for new session.')
			//window.location.href = "/Auth/";
		}

		// at this point the session token was found in storage and not expired.
		// if it is more than half-expired then perform refresh and store/return the result
		// otherwise just return the token
		if (isTimeoutPopup === true) {
			return this.userSessionApiClient
				.refreshSessionJwt(ssoToken)
				.then(sessionJwt => {
					this.jwtStorage.saveJwt(SettingsManager.REACT_APP_SSO_TOKEN_NAME, sessionJwt.accessToken)
					this.jwtStorage.saveJwt(SettingsManager.REACT_APP_Refresh_TOKEN_NAME, sessionJwt.refreshToken)

					return new Promise<string>(resolve => resolve(sessionJwt.accessToken))
				})
				.catch(error => {
					return new Promise<string>(resolve => resolve(''))
				})
		}
		else {
			if (UserSession.getUserSessionFromJwt(ssoToken).isMidBeforeNow()) {
				return this.userSessionApiClient
					.refreshSessionJwt(ssoToken)
					.then(sessionJwt => {
						this.jwtStorage.saveJwt(SettingsManager.REACT_APP_SSO_TOKEN_NAME, sessionJwt.accessToken)
						this.jwtStorage.saveJwt(SettingsManager.REACT_APP_Refresh_TOKEN_NAME, sessionJwt.refreshToken)

						return new Promise<string>(resolve => resolve(sessionJwt.accessToken))
					})
					.catch(error => {
						return new Promise<string>(resolve => resolve(''))
					})
			}
		}
		if (UserSession.getUserSessionFromJwt(ssoToken).isNbfAfterNow()) {
			// session token found but invalid because the NBF is in the future. This MAY happen due to clock skew with client machines!
			// if the NBF is before now from the perspective of the client then we issue a warning on the console and continue
			console.warn(`session token NBF is ${UserSession.getUserSessionFromJwt(ssoToken).nbf} but the current time is ${new Date()} which means NBF is in the future.`)

			return new Promise<string>(resolve => resolve(ssoToken == null ? '' : ssoToken))
		}
		return new Promise<string>(resolve => resolve(ssoToken == null ? '' : ssoToken))
	}
}
